import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'abbreviatedNumber',
  standalone: true
})
export class AbbreviatedNumberPipe implements PipeTransform {

/** Formats spend by magnitude: <1K → $X.XX, 1K–1M → $XXXK (truncated), ≥1M → $XXXM (truncated) */
 transform(amount: number): string {
    if (amount == null || typeof amount !== 'number' || isNaN(amount)) return '';
    if (amount >= 1e6) return `$${Math.floor(amount / 1e6)}M`;
    if (amount >= 1e3) return `$${Math.floor(amount / 1e3)}K`;
    return `$${amount.toFixed(2)}`;
  }

}
